module.exports = __webpack_public_path__ + "static/media/backround-kresno.57bcbf16.png";